import { render, staticRenderFns } from "./CommissionSolshare.vue?vue&type=template&id=675de7c4&scoped=true"
import script from "./CommissionSolshare.vue?vue&type=script&lang=js"
export * from "./CommissionSolshare.vue?vue&type=script&lang=js"
import style0 from "./CommissionSolshare.vue?vue&type=style&index=0&id=675de7c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "675de7c4",
  null
  
)

export default component.exports